<template>
	<div class="c-set-menu effect" style="display: none; right: -3.77rem;" :class="{'show': isShowMenu==true}"  @click="hideMenuAll($event)">
		<div id="menu-inner" class="menu-inner" style="width: 70vw">
			<div class="close-wrap">
				<div class="img" @click="hideMenu()"></div>
			</div>
			<!--div class="user-info border-bottom">
				<div class="user-name"><span >Hi,{{ account.acccode }}</span></div>
				<div class="balance-wrap">
					<div class="balance1 yb_mr4">{{ account.currCode }}<sup>{{ account.currUnit_S }}</sup> {{ account.currCL | ccl(decimals) }}</div>
					<div class="refesh" @click="refreshCcl()"></div>
				</div>
			</div-->
			<div class="set-item">
				<div class="icon set-icon-1"></div>
				<div class="name">{{ lang.home['HOME.SORT']}}</div>
				<div class="option" @click="optionTrigger('sort')">
					<div class="op-item active">{{ sortHot==2 ? lang.home['HOME.BY_HOT'] : lang.home['HOME.BY_TIME'] }}</div>
					<div class="op-icon"></div>
					<div class="op-item">{{ sortHot==2 ? lang.home['HOME.BY_TIME'] : lang.home['HOME.BY_HOT'] }}</div>
				</div>
			</div>
			<!--div class="set-item no-border">
				<div class="icon set-icon-2"></div>
				<div class="name">{{lang.home['HOME.ODDS_FORMAT']}}</div>
				<div class="option option3" @click="showOddsType()">
					<i :class="'odd-'+selectedOdd"></i>
					<div class="op-icon op-icon2"></div>
					<template v-for="odd in odds">
						<div class="op-item active" :id="'odds-'+odd.key" style="font-size: 0.14rem;" v-if="selectedOdd==odd.key">{{ odd.lang }}</div>
					</template>
				</div>
			</div>
			<div class="oddstype-wrap">
				<template v-for="odd in odds">
					<div class="odds-item" :class="{'active':selectedOdd==odd.key}" @click="changeOdd(odd.key)">
						<i :class="'odd-'+odd.key"></i>
						<div class="col">{{ odd.lang }}</div>	
						<div class="icon"></div>
					</div>
				</template>
			</div-->
			<!--div class="set-item no-border" v-if="account.oneWallet!='1'">
				<div class="icon set-icon-4"></div>
				<div class="name"  :style="cookies_lang=='pt_PT'?'font-size:10px':''" >{{lang.home['HOME.BETSLIP']}}</div>
				<div class="option" @click="optionTrigger('bet')">
					<div class="op-item active"  :style="cookies_lang=='pt_PT'?'font-size:10px':''">{{ !betterOdds ? lang.home['HOME.HIGHER_ODDS']  :lang.home['HOME.ANY_ODDS']  }}</div>
					<div class="op-icon"></div>
					<div class="op-item"  :style="cookies_lang=='pt_PT'?'font-size:10px':''">{{ !betterOdds ? lang.home['HOME.ANY_ODDS'] : lang.home['HOME.HIGHER_ODDS'] }}</div>
				</div>
			</div-->
			<div class="line"></div>
			<!--div class="set-item">
				<div class="icon set-icon-3"></div>
				<div class="name">{{lang.home['HOME.EDITION']}}</div>
				<!-- <div class="option" @click="optionTrigger('edition')">
					<div class="op-item active">{{ selectedEdition ? lang.home['HOME.STANDARD'] : lang.home['HOME.STARTER']}}</div>
					<div class="op-icon"></div>
					<div class="op-item">{{ selectedEdition ?lang.home['HOME.STARTER'] :  lang.home['HOME.STANDARD']}}</div>
				</div> -->
				<!--div class="option option3" @click="showEdition()">
					<i class=""></i>
					<div class="op-icon op-icon2"></div>
					<div class="op-item active" id="ed-standard" style="font-size: 0.14rem;" v-if="selectedEdition == '1'">{{lang.home['HOME.STANDARD']}}</div>
					<div class="op-item active" id="ed-starter" style="font-size: 0.14rem;" v-if="selectedEdition == '0'">{{lang.home['HOME.STARTER']}}</div>
					<div class="op-item active" id="ed-special" style="font-size: 0.14rem;" v-if="selectedEdition == '2'">{{lang.home['HOME.EXPAND']}}</div>
					<div class="op-item active" id="ed-special" style="font-size: 0.14rem;" v-if="selectedEdition == '3'">{{lang.home['HOME.SIMPLE_SOCCER']}}</div>
				</div>
			</div-->
			<!--div class="ed-wrap">
				<div class="ed-item" :class="{'active':selectedEdition=='1'}" @click="changeEdition(1)">
					<i :class="'ed-'+selectedEdition"></i>
					<div class="col">{{lang.home['HOME.STANDARD']}}</div>
					<div class="icon"></div>
				</div>
				<div class="ed-item" :class="{'active':selectedEdition=='0'}" @click="changeEdition(0)">
					<i :class="'ed-'+selectedEdition"></i>
					<div class="col">{{lang.home['HOME.STARTER']}}</div>
					<div class="icon"></div>
				</div>
				<div class="ed-item" :class="{'active':selectedEdition=='2'}" @click="changeEdition(2)">
					<i :class="'ed-'+selectedEdition"></i>
					<div class="col">{{lang.home['HOME.EXPAND']}}</div>
					<div class="icon"></div>
				</div>
				<div class="ed-item" :class="{'active':selectedEdition=='3'}" @click="changeEdition(3)">
					<i :class="'ed-'+selectedEdition"></i>
					<div class="col">{{lang.home['HOME.SIMPLE_SOCCER']}}</div>
					<div class="icon"></div>
				</div>
			</div-->
			<div class="set-item no-border">
				<div class="icon set-icon-5"></div>
				<div class="name">{{lang.home['HOME.SWITCH']}}</div>
				<div class="option option3" @click="showLanguage()">
					<i class="lang-icon yb_mr4" :class="{'lang-zh':cookies_lang=='zh_CN', 'lang-tw':cookies_lang=='zh_TW', 'lang-en':cookies_lang=='en_US', 'lang-th':cookies_lang=='th_TH', 'lang-vn':cookies_lang=='vn_VN', 'lang-id':cookies_lang=='id_ID', 'lang-es':cookies_lang=='es_MX', 'lang-pt':cookies_lang=='pt_PT', 'lang-fa':cookies_lang=='fa_IR', 'lang-ja':cookies_lang=='ja_JP', 'lang-ko':cookies_lang=='ko_KR'}"></i>
					<div class="op-icon op-icon2"></div>
					<div class="op-item active lgSelect" id="zh-TW" style="font-size: 0.14rem;" v-if="cookies_lang=='zh_TW'">{{ langSelect[3].caption }}</div>
					<div class="op-item active lgSelect" id="en-US" style="font-size: 0.14rem;" v-if="cookies_lang=='en_US'">{{ langSelect[1].caption }}</div>
					<div class="op-item active lgSelect" id="zh_CN" style="font-size: 0.14rem;" v-if="cookies_lang=='zh_CN'">{{ langSelect[2].caption }}</div>
					<div class="op-item active lgSelect" id="th-TH" style="font-size: 0.14rem;" v-if="cookies_lang=='th_TH'">{{ langSelect[5].caption }}</div>
					<div class="op-item active lgSelect" id="vn-VN" style="font-size: 0.14rem;" v-if="cookies_lang=='vn_VN'">{{ langSelect[6].caption }}</div>
					<div class="op-item active lgSelect" id="id-ID" style="font-size: 0.14rem;" v-if="cookies_lang=='id_ID'">{{ langSelect[7].caption }}</div>
					<div class="op-item active lgSelect" id="es-MX" style="font-size: 0.14rem;" v-if="cookies_lang=='es_MX'">{{ langSelect[8].caption }}</div>
					<div class="op-item active lgSelect" id="pt-PT" style="font-size: 0.14rem;" v-if="cookies_lang=='pt_PT'">{{ langSelect[9].caption }}</div>
					<div class="op-item active lgSelect" id="fa-IR" style="font-size: 0.14rem;" v-if="cookies_lang=='fa_IR'">{{ langSelect[10].caption }}</div>
					<div class="op-item active lgSelect" id="ja-JP" style="font-size: 0.14rem;" v-if="cookies_lang=='ja_JP'">{{ langSelect[4].caption }}</div>
					<div class="op-item active lgSelect" id="ko-Kr" style="font-size: 0.14rem;" v-if="cookies_lang=='ko_KR'">{{ langSelect[11].caption }}</div>
				</div>
			</div>
			<div class="lang-wrap">
				<div class="lang-item" :class="{'active':cookies_lang=='en_US'}" @click="changeLanguage(1)">
					<i class="lang-icon yb_mr4 lang-en"></i>
					<div class="col">{{ langSelect[1].caption }}</div>
					<div class="icon"></div>
				</div>
				<div class="lang-item" :class="{'active':cookies_lang=='zh_CN'}" @click="changeLanguage(2)">
					<i class="lang-icon yb_mr4 lang-zh"></i>
					<div class="col">{{ langSelect[2].caption }}</div>
					<div class="icon"></div>
				</div>
				<div class="lang-item" :class="{'active':cookies_lang=='zh_TW'}" @click="changeLanguage(3)">
					<i class="lang-icon yb_mr4 lang-tw"></i>
					<div class="col">{{ langSelect[3].caption }}</div>
					<div class="icon"></div>
				</div>
				<div class="lang-item" :class="{'active':cookies_lang=='th_TH'}" @click="changeLanguage(5)">
					<i class="lang-icon yb_mr4 lang-th"></i>
					<div class="col">{{ langSelect[5].caption }}</div>
					<div class="icon"></div>
				</div>
				<div class="lang-item" :class="{'active':cookies_lang=='vn_VN'}" @click="changeLanguage(6)">
					<i class="lang-icon yb_mr4 lang-vi"></i>
					<div class="col">{{ langSelect[6].caption }}</div>
					<div class="icon"></div>
				</div>
				<div class="lang-item" :class="{'active':cookies_lang=='id_ID'}" @click="changeLanguage(7)">
					<i class="lang-icon yb_mr4 lang-id"></i>
					<div class="col">{{ langSelect[7].caption }}</div>
					<div class="icon"></div>
				</div>
				<div class="lang-item" :class="{'active':cookies_lang=='es_MX'}" @click="changeLanguage(8)">
					<i class="lang-icon yb_mr4 lang-es"></i>
					<div class="col">{{ langSelect[8].caption }}</div>
					<div class="icon"></div>
				</div>
				<div class="lang-item" :class="{'active':cookies_lang=='pt_PT'}" @click="changeLanguage(9)">
					<i class="lang-icon yb_mr4 lang-pt"></i>
					<div class="col">{{ langSelect[9].caption }}</div>
					<div class="icon"></div>
				</div>
				<div class="lang-item" :class="{'active':cookies_lang=='fa_IR'}" @click="changeLanguage(10)">
					<i class="lang-icon yb_mr4 lang-fa"></i>
					<div class="col">{{ langSelect[10].caption }}</div>
					<div class="icon"></div>
				</div>
				<div class="lang-item" :class="{'active':cookies_lang=='ja_JP'}" @click="changeLanguage(4)">
					<i class="lang-icon yb_mr4 lang-ja"></i>
					<div class="col">{{ langSelect[4].caption }}</div>
					<div class="icon"></div>
				</div>
				<div class="lang-item" :class="{'active':cookies_lang=='ko_KR'}" @click="changeLanguage(11)">
					<i class="lang-icon yb_mr4 lang-ko"></i>
					<div class="col">{{ langSelect[11].caption }}</div>
					<div class="icon"></div>
				</div>
			</div>
			<div class="line"></div>
			<!--div class="set-item no-border" @click="toTemplate(10,0)">
				<div class="icon set-icon-6"></div>
				<div class="name">{{lang.loginTitle['LOGIN.RULES']}}</div>
				<div class="option option2">
					<div class="yb-icon-arrow right"></div>
				</div>
			</div>
			<div class="set-item no-border" :class="account.previewFlag?'disabled':''" @click="toTemplate(16,0)">
				<div class="icon set-icon-6"></div>
				<div class="name">{{lang.AnnouncementsLang['ANNOUNCEMENTS.ANNOUNCEMENTS']}}</div>
				<div class="option option2">
					<div class="yb-icon-arrow right"></div>
				</div>
			</div>
			<div class="set-item no-border" :class="account.previewFlag?'disabled':''" @click="showAccSetting()">
				<div class="icon set-icon-5"></div>
				<div class="name">{{lang.accountSetting['ACCOUNT.HEADER_ACCOUNT_SETTINGS']}}</div>
				<div class="option option3">
					<div class="op-icon op-icon2"></div>
				</div>
			</div>
			<div class="acc_setting">
				<div class="setting-item"  @click="toTemplate(8,1)">
					<div class="col">{{ lang.accountSetting['ACCOUNT.HEADER_BETTING_LIMIT'] }}</div>
					<div class="icon"></div>
				</div>
				<div class="setting-item" @click="toTemplate(8,2)">
					<div class="col">{{ lang.accountSetting['ACCOUNT.HEADER_CHIP_SETTINGS'] }}</div>
					<div class="icon"></div>
				</div>
				<div class="setting-item" @click="toTemplate(8,5)">
					<div class="col">{{ lang.home['HOME.home_setting'] }}</div>
					<div class="icon"></div>
				</div>
			</div>
			<div class="line"></div-->
			<div class="set-item">
				<div class="icon set-icon-7"></div>
				<div class="name">{{lang.home['HOME.SKIN']}}</div>
				<div class="skin-wrap" id="toggleTheme">
					<!-- 1 am 2 pm -->
					<div class="skin-icon skin-icon1" @click="changeSkin(1)"></div> 
					<div class="skin-icon skin-icon2" @click="changeSkin(2)"></div>
				</div>
			</div>
			<div class="set-item no-border" v-if="timeZone.format>0">
				<div class="name" style="margin-left:2em">{{lang.home['HOME.TIMEZONE']}}</div>
				<div class="option option3" @click="showTimeZone()" v-if="timeZone.format==1">
					<div class="op-icon op-icon2"></div>
					<template v-for="(dt , index)  in timeZone.list">
						<div class="op-item active" :id="'tZ-'+index" style="font-size: 0.14rem;" v-if="selectedTimeZone==index">{{ index }}</div>
					</template>
				</div>
				<div class="option option3" v-if="timeZone.format==2">
					<div>{{ timeZone.default }}</div>
				</div>
			</div>
			<div class="timeZone-wrap" v-if="timeZone.format==1">
				<template v-for="(dt , index)  in timeZone.list">
					<div class="odds-item" :class="{'active':selectedTimeZone==index}" @click="changeTimeZone(index)">
						<div class="col">{{ index }}</div>	
						<div class="icon"></div>
					</div>
				</template>
			</div>
		</div>
		<div class="text-toast" id="successChip_msg" style="display:none">{{lang.info7}}</div>
	</div>
	
</template>
	
<script>
	 import {
		mapGetters
	  } from 'vuex'
	  import EventBus from '@/vue/events/event-bus'
	//   import numberFilter from '@/vue/filters/vue-filter-number'
	  import vueCookie from 'vue-cookie'
	  export default {
		computed: {
		  ...mapGetters([
			'account',
			'timeZone',
			'oddsFormatDec',
			'betSlipAny',
			'editionStand',
			'previous_edition',
			'skinTheme',
			'sortHot',
			'isOtr',
			'betterOdds',
			'isParlay',
		  ]),
		  market:function(){
			return this.$store.getters.market
		  },
		  decimals: function(){
			return this.account.showDecimals ? 2 : 0
		  }
		},
		components: {
	
		},
		props:{
			isShowMenu: Boolean,
		},
		data() {
			return {
				lang: window.lang,
				cookies_lang: window._cookie,
				odds: window.odds,
				selectedOdd: null,
				selectedTimeZone: null,
				selectedEdition:null,
				selectedMarket: null,
				selectedSkinTheme:null,
				selectedBetterOdds:null,
				eventId: null,
				annCount: 0,
				token: window.token,
				isP: true,
				isShowBalance: 'true',
				lobby: window.lobby,
				lobbyUrl: window.lobbyUrl,
				langSelect: lang_select,
				timerSeconds: 60,
          			timerSec: 60,
			}
		},
		methods: {
			showOdds(){
				if(!$('#selec_oddstype').hasClass("on")) {
					$('#selec_oddstype').addClass('on');
				} else {
					$('#selec_oddstype').removeClass('on');
				}
		
				if($('#selec_language').hasClass("on")) {
					$('#selec_language').removeClass('on');
				}
			},
			changeOdd(selectedOdd) {
				this.selectedOdd = selectedOdd;
				this.$store.commit('SELECTED_ODD', this.selectedOdd)
				if(this.$store.getters.latestInfo!=null){
					this.$store.dispatch('getLatestInfo', { token: token.arr_4 })
				}
				
				if(!this.account.previewFlag){
					this.$ajax({
						url: _baseUrl + '/account-def-settings',
						type: 'get',
						data: {
							action: 'updateAccountSportSetting',
							odd: this.selectedOdd
						}
					}).done(response => {
						
					})
				}
				this.showOddsType();
				if(this.isOtr){
					EventBus.$emit('refreshSportOutrightTable')
				}else{
					// EventBus.$emit('refreshSportTable')
					EventBus.$emit('BottomNavRefresh')
				}
			},
			changeEdition(selectedEdition){
				this.selectedEdition = selectedEdition;
				this.$store.commit('EDITIONSTAND', this.selectedEdition)
				if(this.selectedEdition != 3){
					this.$store.commit('PREVIOUS_EDITION', this.selectedEdition)
				}
				this.showEdition()
				EventBus.$emit('resetTimer')
				if(this.isParlay && this.$store.getters.arr_selectedTemplate.templateId == 21){
					EventBus.$emit('parlaySportTemplate', 'N1')
				}else{
					EventBus.$emit('sportTemplate', 'N1')
				}
				// EventBus.$emit('refreshSportTable')

				$('.sport-m-container').removeClass('shadow-down simple1').addClass('shadow-up')
				$('.sub-menu-date-w').removeClass('simple1')
				$('.container-menu-w').removeClass('scrolling-up').addClass('scrolling-down')
			},
			changeTimeZone(selectedTimeZone) {
				this.selectedTimeZone = selectedTimeZone;
				this.$store.commit('TIME_ZONE', this.selectedTimeZone)
				this.showTimeZone();
					// EventBus.$emit('refreshSportTable')
					EventBus.$emit('BottomNavRefresh')
			},
			showTimeZone(){
				var active = $('.timeZone-wrap').hasClass("active");
				if(active){
					$('.timeZone-wrap').removeClass("active");
				}else{
					$('.timeZone-wrap').addClass("active");
				}
			},
			showLanguage(){
				var active = $('.lang-wrap').hasClass("active");
				if(active){
					$('.lang-wrap').removeClass("active");
				}else{
					$('.lang-wrap').addClass("active");
					$('.ed-wrap').removeClass("active");
					$('.oddstype-wrap').removeClass("active");
					$('.acc_setting').removeClass("active");
				}

			},
			showAccSetting(){
				var active = $('.acc_setting').hasClass("active");
				if(!this.account.previewFlag){
					if(active){
						$('.acc_setting').removeClass("active");
					}else{
						$('.acc_setting').addClass("active");
						$('.lang-wrap').removeClass("active");
						$('.ed-wrap').removeClass("active");
						$('.oddstype-wrap').removeClass("active");
					}
				}else{
					
					$("#successChip_msg").show()
               setTimeout('$("#successChip_msg").hide()',1500);
				}
				
			},
			showOddsType(){
				var active = $('.oddstype-wrap').hasClass("active");
				if(active){
					$('.oddstype-wrap').removeClass("active");
				}else{
					$('.oddstype-wrap').addClass("active");
					$('.acc_setting').removeClass("active");
					$('.lang-wrap').removeClass("active");
					$('.ed-wrap').removeClass("active");
				}
			},
			showEdition(){
				var active = $('.ed-wrap').hasClass("active");
				if(active){
					$('.ed-wrap').removeClass("active");
				}else{
					$('.ed-wrap').addClass("active");
					$('.oddstype-wrap').removeClass("active");
					$('.lang-wrap').removeClass("active");
				}
			},

			changeLanguage(selectedLangauge) {
				this.loading = true
				$('.loading').show();
				this.$ajax({
					url: '',
					type: 'get',
					data: {
						language: selectedLangauge,
						token: token.arr_3,
						action: 'changeLanguage',
					},
				}).then(response => {
					var url = window.location.href
					//if url has param langs, eg. preview?sport=2&langs=3&ot=2&hdp=0
					if (url.indexOf('langs') != -1) {
						var url_temp = url.split("langs") // [0]:preview?sport=2&' [1]:'=3&ot=2&hdp=0'
						// check if the last char of first part url after split has '&', if yes remove '&''
						var new_url = url_temp[0].slice(-1) == '&'? url_temp[0].slice(0, -1) : url_temp[0]
						// check if the second part url after split contains others params by checking '&'
						if(url_temp[1].indexOf('&') != -1) {
							var url_rest = url_temp[1].split(/&(.*)/) // get the rest param, eg. '=3&ot=2&hdp=0' => 'ot=2&hdp=0'
							window.location.href = new_url + (new_url.slice(-1) == '?'? '':'&') + url_rest[1]
						} else {
							window.location.href = new_url
						}
					} else {
						window.location.reload();
					}
				})
				this.showLanguage();
			},
			showLogout(){
				if(this.account.isApi && !this.account.showDemo){
					return false
				}
				return true
			},
			logout () {
				this.$store.dispatch('logoutAccount')
				// window.location.href = 'login'
			},
			showSwitchOldSite(){
				if(this.account.hgOldSite){
					return true
				}
				return false
			
			},
			switchOldSite () {
				//this.$store.dispatch('switchOldSite')
				window.location.href = '../whg/home'
			},
			closeMenu(){
				$('#accountMenu').removeClass('on')
			},
			showBalance() {
				if($('#acc_show_eye').hasClass('off')) {
						$('#acc_show_eye').removeClass('off');
						this.isShowBalance = 'false';
		
				} else {
						$('#acc_show_eye').addClass('off');
						this.isShowBalance = 'true';
				}
			},
			toTemplate(ItemplateId, IsubTemplateId){
				if(ItemplateId == 16){
					if(account.previewFlag){
						$("#successChip_msg").show()
						setTimeout('$("#successChip_msg").hide()',1500);
						return false
					}
				}
				$('.loading').show();
				this.closeMenu()
				if(this.account.previewFlag && (ItemplateId!=10 && ItemplateId!=11 && ItemplateId!=12 && ItemplateId!=13)){
					return false;
				}
				if(ItemplateId == 14){
					this.$store.dispatch('getOpenBet',{
						wgrTyp: 'openBet',
					})
				}
				this.$store.dispatch('changeTemplate', {
					templateId: ItemplateId,
					subTemplateId: IsubTemplateId,
		
				})
			
			},
			showLobby() {
				if(this.lobby != '' && this.lobbyUrl != ''){
					if(this.lobby != null && this.lobbyUrl != null){
						return true
					}
				}
				return false
			},
			backToLobby() {
				if(window.self !== window.top){
					window.top.location.href =this.lobbyUrl
				}else{
					window.location.href = this.lobbyUrl
				}
			},
			hideMenu() {
				this.$emit('updateShowMenu', false)
				$('.c-set-menu').hide()
			},
			hideMenuAll(event) {
				if(event.target.id == "menu-inner")
          			return;
       			if($(event.target).closest('#menu-inner').length)
          			return;  
				this.$emit('updateShowMenu', false)
				$('.c-set-menu').hide()
			},
			refreshCcl() {
				$('.balance-wrap').find('.refesh').addClass('rotate');
				if(!this.account.previewFlag){
					this.$store.dispatch('getSportCCL', {
						token: token.arr_5
					})
				}
			},
			optionTrigger(option){
				if(option == 'sort'){
					/*if(this.$store.getters.sortHot == '1'){
						this.$store.commit('SORTHOT', 0)
						vueCookie.set('sort', 0);
					}else{
						this.$store.commit('SORTHOT', 1)
						vueCookie.set('sort', 1);
					}*/
						// this.$store.commit('S_ODD', true)
					var sortId = this.$store.getters.sortHot == '1' ? '2' : '1'
					this.$store.commit('SORT_HOT', sortId);
				}else if(option == 'odd'){
					if(this.$store.getters.oddsFormatDec == '1'){
						this.$store.commit('ODDSFORMATDEC', 0)
					}else{
						this.$store.commit('ODDSFORMATDEC', 1)
					}
				}else if(option == 'bet'){
					var account = this.$store.getters.account
					
					if(this.$store.getters.betterOdds == '1'){  
					// if(this.selectedBetterOdds == '1'){  
						this.$store.commit('BETTER_ODDS', 0)
						account.autoAccBetterOdd = 1
					}else{
						this.$store.commit('BETTER_ODDS', 1)
						account.autoAccBetterOdd = 2
					}
					
					this.$store.commit('ACCOUNT', account)
				}else if(option == 'edition'){
					if(this.selectedEdition == '1'){
						this.selectedEdition = 0;
						this.$store.commit('EDITIONSTAND', this.selectedEdition)
					}else{
						this.selectedEdition = 1;
						this.$store.commit('EDITIONSTAND',this.selectedEdition)
					}
				}
				
					// EventBus.$emit('refreshSportTable')
					EventBus.$emit('BottomNavRefresh')
			},
			changeSkin(theme) {
				if(this.$store.getters.skinTheme==2){
					this.$store.commit('SKIN_THEME', 1)
				}else{
					this.$store.commit('SKIN_THEME', 2)
				}
				
				if(!this.account.previewFlag){
					this.$ajax({
						url: _baseUrl + '/account-def-settings',
						type: 'get',
						data: {
							action: 'updateAccountSportSetting',
							theme: this.$store.getters.skinTheme
						}
					}).done(response => {
						
					})
				}
				document.documentElement.classList.toggle('theme02');
			},
			startTimer() {
				this.clearTimer()
				this.timerSeconds = 60
				if(this.timerIdccl == null){
					this.timerIdccl = setInterval(() => {
						if(this.timerSeconds - 1 < 0) {
							this.$store.dispatch('getSportCCL',{
								token: token.arr_7
							})
							this.timerSeconds = this.timerSec
						} else {
							this.timerSeconds -= 1;
						}
					},1000);
				}
			},
			clearTimer() {
				clearInterval(this.timerIdccl)
				this.timerIdccl = null
			},
		},
		beforeMount() {
			if (!this.account.previewFlag) {
				this.startTimer()
			}
			// var accCookie = JSON.parse(this.$cookie.get(window.compcode+ '_acc'))
			var accCookie = this.$store.getters.accSetting
			this.selectedOdd = accCookie.oddsType;
			this.selectedTheme = this.$store.getters.skinTheme;
			this.selectedEdition = this.$store.getters.editionStand;
			this.selectedBetterOdds = this.$store.getters.betterOdds;
			this.selectedTimeZone = this.$store.getters.timeZone.default;
			if(vueCookie.get('UID') && JSON.parse(vueCookie.get('UID')).usrn) {
				var usrn = JSON.parse(vueCookie.get('UID')).usrn
				if(usrn == '-1' || !JSON.parse(vueCookie.get('UID')).nsid){
					this.isP = true
				} else {
					this.isP = false
				}
			}
		},
		mounted:function(){
		},
		updated(){
			this.selectedEdition = this.$store.getters.editionStand;
		},
	  }
	</script>


// WEBPACK FOOTER //
// resources/score/vue/apps/home/accountMenu.vue